import { faCheck } from '@fortawesome/free-solid-svg-icons';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import { isMobile } from 'react-device-detect';
import BasicTab from '../../../components/form/BasicTab';
import MyButton from '../../../components/form/MyButton';
import TabPanel from '../../../components/layout/TabPanel';


const OngletCommandes = (props) => {
  const { classes, value, auth, width, setSelectedCommand, entryCommand, setEntryCommand, commandesReferences,
    handleSendCommande, btnSendCommandeIsLoading, handleOpenResponseCommand, handleOpenLogCommand, commandes, wsStatus } = props;

  const handleChange = (e, newValue, reason) => {
    console.log('handleChange');
    if (newValue?.commande) {
      console.log('handleChange ' + newValue);
      setSelectedCommand(newValue);
      return newValue;
    }
    return null;
  };

  const handleInputChange = (e, data) => {
    console.log('handleInputChange');
    if (data) {
      console.log('handleInputChange ' + data);
      setEntryCommand(data);
      setSelectedCommand(null);
      return data;
    }
    return null;
  };

  const handleKeyPress = (e) => {
    console.log('handleKeyPress');
    if (e.key === "Enter" || e.nativeEvent.code === 'Enter' || e.nativeEvent.code === 'NumpadEnter') {
      handleSendCommande();
    }
    return null;
  };

  if (isMobile) {
    return (
      <TabPanel className={classes.tabPanel} value={value} index={1}>
        <div className="row" style={{ flexDirection: 'column', borderBottom: '2px solid #E4E8EC', paddingBottom: '5px', margin: '0px 10px 0 10px' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '2.5vw', justifyContent: 'space-between', margin: '0' }}>Envoi de commande

            {
              props.wsStatus &&
              <MyButton
                className="classic-button btn-default color-fond-vert"
                type="button"
                labelImportant="Envoyer la commande"
                href="#"
                iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                onClick={() => handleSendCommande()}
                isLoading={btnSendCommandeIsLoading}
              />
            }
            {
              !props.wsStatus &&
              <MyButton
                className="classic-button btn-default color-fond-gris"
                type="button"
                labelImportant="Envoyer la commande"
                href="#"
                iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
                styleCss={{ cursor: 'default' }}
              />
            }
          </div>
          <Autocomplete
            freeSolo
            onChange={(e, data, reason) => handleChange(e, data, reason)}
            onInputChange={(e, data) => handleInputChange(e, data)}
            onKeyPress={(e) => handleKeyPress(e)}
            options={commandesReferences}
            getOptionLabel={(option) => option?.commande?`[${option.libelle}] > ${option.commande}`:''}
            renderInput={(params) => (
              <TextField {...params} label="Commande" variant="outlined" style={{ marginBottom: '10px' }} />
            )}
          />
        </div>
        <div className="row" style={{ flexDirection: 'column', borderBottom: '2px solid #E4E8EC', paddingBottom: '5px', margin: '10px 10px 0 10px' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '2.5vw', justifyContent: 'space-between', margin: '0 0 10px 0' }}>Historique des commandes</div>
          <BasicTab
            style={{
              header: {
                row: {
                  backgroundColor: '#F0F3F6',
                  fontSize: '2.5vw',
                },
              },
              datas: {
                row: {
                  borderBottom: '1px solid #EBEEF1',
                  fontSize: '2.5vw',
                },
              },
            }}
            width={'100%'}
            headers={['date d\'envoi', 'commande', '']}
            columns={['dateEnvoi', 'commande']}
            datas={commandes}
            auth={auth}
            showLog={true}
            handleOpenLog={handleOpenLogCommand}
            showResponse={true}
            handleOpenResponse={handleOpenResponseCommand}
          />
          <div style={{ marginBottom: '10px' }} />
        </div>
      </TabPanel>
    );
  }

  return (
    <TabPanel className={classes.tabPanel} value={value} index={1} style={{ width: '100%' }}>
      <div className="overflow-auto" style={{ overflow: 'auto', height: 'calc(90vh - 145px)' }}>
        <div className="row" style={{ flexDirection: 'column' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '1vw' }}>Envoi de commande</div>
          <div className="row" style={{ flexDirection: 'row' }}>
            <div style={{width: 'calc(100% - 21vw)'}}>
          <Autocomplete
            freeSolo
            inputValue={entryCommand}
            onChange={(e, data, reason) => handleChange(e, data, reason)}
            onInputChange={(e, data) => handleInputChange(e, data)}
            onKeyPress={(e) => handleKeyPress(e)}
            options={commandesReferences}
            getOptionLabel={(option) => option?.commande?`[${option.libelle}] > ${option.commande}`:''}
            renderInput={(params) => (
              <TextField {...params} label="Commande" margin="normal" variant="outlined" style={{margin: 0, padding: 0}} />
            )}
            disabled={!props.wsStatus}
          />
            </div>
            <div style={{width: '21vw', display: 'flex', justifyContent: 'center'}}>

          {
            props.wsStatus && <MyButton
              className="classic-button btn-default color-fond-vert"
              type="button"
              labelImportant="Envoyer la commande"
              href="#"
              iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
              onClick={() => handleSendCommande()}
              isLoading={btnSendCommandeIsLoading}
            />
          }
          {
            !props.wsStatus && <MyButton
              className="classic-button btn-default color-fond-gris"
              type="button"
              labelImportant="Envoyer la commande"
              href="#"
              iconLeft={{ icon: faCheck, type: 'fontAwesome' }}
              styleCss={{ cursor: 'default' }}
            />
          }
            </div>
          </div>
        </div>
        <div className="row" style={{ flexDirection: 'column', marginTop: '50px' }}>
          <div className="title-sub-rubrique" style={{ fontSize: '1vw' }}>Historique des commandes</div>
          <BasicTab
            style={{
              header: {
                row: {
                  backgroundColor: '#F0F3F6',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
              datas: {
                row: {
                  borderBottom: '1px solid #EBEEF1',
                  fontSize: width > 1400 ? '0.75vw' : '1vw',
                },
              },
            }}
            width={'100%'}
            headers={['date d\'envoi', 'commande', 'reponse', 'utilisateur', '']}
            columns={['dateEnvoi', 'commande', 'reponse', 'utilisateur']}
            datas={commandes}
            auth={auth}
            showLog={true}
            handleOpenLog={handleOpenLogCommand}
          />
        </div>
      </div>
    </TabPanel>
  );

};

export default OngletCommandes;